
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/obchodni-tym",
      function () {
        return require("private-next-pages/obchodni-tym.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/obchodni-tym"])
      });
    }
  